import React from 'react';
import './reportTestReferenceContent.css';

const ReportTestReferenceContent = () => {
    return (
        <div className="content-container-ref">
            <h2>Prostatype Genomic Classifier Description:</h2>
            <p>
                The Prostatype Genomic Classifier® was developed and validated from prostate biopsy tissue and is intended to guide treatment decisions for 
                patients currently on or that are considering active surveillance. The P-Score is calculated based on mRNA expression of a three gene 
                prostate cancer stem cell signature (IGFBP3, F3, VGLL3) combined with clinicopathological information obtained at diagnosis. 
                Gene expression is measured by real-time quantitative polymerase chain reaction in formalin-fixed paraffin-embedded tumor material 
                from the patient’s core needle biopsy at diagnosis. A point-based scoring system based on a Fine-Gray competing risk model was used 
                to establish the P-score for the prediction of adverse pathology, metastatic risk and risk of prostate cancer specific mortality. 
                Prostatype classifies patients into one of three risk categories (low, intermediate, or high) based on the P-score, to support 
                clinical decisions related to active surveillance versus curative treatment.
            </p>
            
            

            <h2>Intended Use:</h2>
            <p>
                The Prostatype Genomic Classifier is intended for use in men with localized adenocarcinoma of the prostate (i.e. no clinical evidence of metastasis) who have a life expectancy of greater than or equal to 10 years if they are a candidate for and are considering (or being considered for) conservative management and yet would be eligible for curative intent treatments (radical prostatectomy (RP) or radiation therapy).
            </p>
           
            <h2>References:</h2>

            <p className="reference-item">
                1) &nbsp; Validation of the prognostic value of a three-gene signature and clinical parameters- based risk score in prostate cancer patients. Sæmundsson et al, The Prostate 2023, 2) Precise risk stratification of prostate cancer by P-score in an Asian population. See-Tong Pang et al., Data on File, 3) P-Score in preoperative biopsies accurately predicts P-Score in final pathology at radical prostatectomy in patients with localized prostate cancer, Röbeck et al, The Prostate 2023, 4) A Novel Risk Score (P-Score) Based on a Three-Gene Signature For Estimating the Risk of Prostate Cancer-Specific Mortality, Söderdahl et al, Research and Reports in Urology 2022, 5) Improving the prediction of prostate cancer overall survival by supplementing readily available clinical data with gene expression levels of IGFBP3 and F3 in formalin-fixed paraffin embedded core needle material, Peng et al, PLOS One 2015, 5) An expression signature at diagnosis to estimate prostate cancer patients’ overall survival, Peng et al, PCPD 2014
            </p>

            <p className="reference-item">
                2) * Based on NCCN Risk Classification.
            </p>


                          
            <h2 className='lab-director'>Laboratory Director:</h2>
            <p>Petros Giannikpoulos, M.D. <br/>
                CLIA: 05D2224970 CAP: 8885880
            </p>

            <br />

            <p className='content-reference-footnote'>
                Prostatype test is regulated under the Clinical Laboratory Improvement Amendments of 1988 (CLIA) as qualified to 
                perform high-complexity clinical testing. The Prostatype P-Score for Active Surveillance test was developed, and 
                its performance characteristics determined by Prostatype Genomics. It has not been cleared or approved by the 
                US Food and Drug Administration (FDA). After verifying the accuracy of the clinical information provided to 
                calculate the risk score above, the test results must be interpreted in conjunction with other laboratory 
                and clinical data available to the clinician and relevant guidelines on the decision for treatment. 
                This test was performed by Prostatype Genomics Inc. This test is used for clinical purposes. 
                It should not be regarded as investigational or for research.
            </p>
        </div>
    );
};

export default ReportTestReferenceContent;
